import axios from "../../../services/axios-config";

export async function getCompanyCustomers({ companyId }) {
  const response = await axios.get("/admin/companies/customers", {
    params: { companyId },
  });

  return response?.data?.customers || [];
}
